module.exports = __webpack_public_path__ + "img/SentimentSatisfiedOutlined.55f1ee98.svg";